import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Section } from './Section';
const POINTS = ['Devolución simple', 'Sin formularios molestos', 'Te quedas con los bonos'];
export function Guarantee() {
  return <Section className="bg-cream-50" data-id="element-184" data-mp="222dcbm8qewod">
      <div className="rounded-[2rem] border border-ink-950/10 bg-white p-7 text-center sm:p-10" data-id="element-185" data-mp="221bxd6olhq1d">
        <span className="mx-auto mb-6 flex h-14 w-14 items-center justify-center rounded-2xl bg-emerald-500/10" data-id="element-186" data-mp="1x28rxl4pdhsv">
          <ShieldCheckIcon className="h-7 w-7 text-emerald-600" aria-hidden="true" data-id="element-187" data-mp="19cejrgvbwhey" />
        </span>

        <p className="text-xs font-bold uppercase tracking-[0.22em] text-emerald-700" data-id="element-188" data-mp="14dthzd0fhpoe">
          Riesgo cero · 100% protegido
        </p>
        <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-tight text-ink-950 sm:text-4xl" data-id="element-189" data-mp="1edke1j4n0cql">
          Garantía de devolución de 10 días
        </h2>

        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-ink-800/80" data-id="element-190" data-mp="lp6aknus4o7n">
          Accede al contenido y aplícalo. Si sientes que no aprendiste nada
          útil, que no era lo que esperabas o simplemente que no era para ti,
          puedes solicitar tu devolución dentro de los 10 días desde tu compra.
          Sin preguntas complicadas, sin procesos molestos.
        </p>

        <ul className="mx-auto mt-8 flex flex-wrap justify-center gap-2" data-id="element-191" data-mp="12qwt3se9byhj">
          {POINTS.map(point => <li key={point} className="rounded-full border border-ink-950/10 bg-cream-100 px-4 py-2 text-[11px] font-semibold uppercase tracking-wide text-ink-950/65" data-id="element-192" data-mp="12sr7env0wscn">
              {point}
            </li>)}
        </ul>

        <p className="mt-6 text-sm font-semibold text-ink-950" data-id="element-193" data-mp="f0u4jm9jxano">
          Así de simple. Así de justo.
        </p>
      </div>
    </Section>;
}